import { IconAlertTriangleFilled } from '@tabler/icons-react'

import { NewCheckoutModalForm } from 'features/checkout'
import Text from 'components/ui/text'
import { isPaidUser } from 'utils/freeVersionBlock'
import { shouldUpdateBillingInfo } from 'utils/userAuth'
import { MIXPANEL_PROPS } from 'utils/mixpanel'

import { PaymentList } from '../payment-list'

interface UpdatePaymentFormProps {
  onRequestClose: () => void
}

export const UpdatePaymentForm = ({
  onRequestClose,
}: UpdatePaymentFormProps) => {
  return (
    <div className="tw-flex tw-w-full tw-flex-col sm:tw-p-2">
      <Text className="tw-m-0 tw-p-0 tw-text-left tw-text-2xl tw-font-medium tw-text-zinc-950">
        update_billing_info
      </Text>
      {isPaidUser() && shouldUpdateBillingInfo() && (
        <div className="tw-mt-6 tw-flex tw-items-center tw-justify-center tw-gap-3 tw-rounded-lg tw-bg-yellow-50 tw-p-4">
          <IconAlertTriangleFilled className="tw-min-h-7 tw-min-w-7 tw-text-yellow-400" />
          <Text className="tw-m-0 tw-text-sm">
            old_lifetime_update_billing_info_modal
          </Text>
        </div>
      )}
      <PaymentList source={MIXPANEL_PROPS.SOURCE.values.BILLING_PAGE} />
      <div className="tw-relative tw-flex tw-w-full tw-justify-center before:tw-absolute before:tw-left-0 before:tw-top-1/2 before:tw-h-px before:tw-w-full before:tw-translate-y-1/2 before:tw-bg-zinc-200 before:tw-content-['']">
        <Text className="tw-z-1 tw-tacking-[0.5px] tw-relative tw-my-4 tw-bg-white tw-px-2 tw-py-0 tw-text-center tw-text-xs tw-uppercase tw-text-zinc-500 xs:tw-my-6">
          or_update_card
        </Text>
      </div>
      <NewCheckoutModalForm
        className="tw-mt-0 tw-flex tw-flex-grow tw-justify-start"
        confirmButton={{
          text: 'save_changes',
          className: 'tw-w-full tw-h-10',
          textClassName: 'tw-text-base',
        }}
        cancelButton={{
          text: 'cancel',
          className:
            'tw-w-full tw-h-9 tw-rounded-md tw-text-base tw-font-medium',
          onClose: onRequestClose,
        }}
        checkoutSuccessSource={MIXPANEL_PROPS.SOURCE.values.BILLING_PAGE}
      />
    </div>
  )
}
